import React, { useCallback } from 'react';
import { useGameImageUrls } from 'js/hooks/games';
import { Image } from 'js/components/common/Image';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './CarouselItem.scss';

export const CarouselItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, setWinnerItemRef, className } = props;
    const translate = useComponentTranslations();
    const imageUrls = useGameImageUrls({ code });

    const openGame = useCallback(() => publicEventsAPIService.trigger('game:launch', {
        code,
        mode: 1,
        container: 'top-winners'
    }), [code]);

    return (
        <AccessibilityElement
            onClick={openGame}
            elementRef={setWinnerItemRef}
            className={`${style.carouselContainer} ${className}`}
            aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${gameName}`}
        >
            <div className={style.imageContainer}>
                <Image
                    alt={gameName}
                    src={imageUrls}
                    className={style.image}
                />
            </div>
            <div className={style.columnInfo}>
                <span className={`${style.justWon} ${style.ellipsis}`}>{`${player} ${translate('justWon')}`}</span>
                <span className={style.winAmount}>{winAmount}</span>
                <span className={style.ellipsis}>{`${translate('inGame')} ${gameName}`}</span>
            </div>
        </AccessibilityElement>
    );
};
